import gql from 'graphql-tag'

export default gql`
  query getSubject($id: Int!) {
    getSubject(id: $id) {
      id
      email
      details {
        id
        label
        title
        language_code
      }
      parent_id
      parent {
        id
        detail {
          id
          label
          title
          language_code
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/subject/get.js